import React, {useEffect, useState} from 'react';
import {CommonServerSideParams} from '@/app/types/CommonServerSideParams';
import {OnlyBrowserPageProps} from '@/layouts/web/types/OnlyBrowserPageProps';
import {SSGPageProps} from '@/layouts/web/types/SSGPageProps';
import ReactDivWebMain from '@/modules/core/reactDivWeb/components/Web/Main/Main';
import WebLayout from '@/layouts/web/components/WebLayout';
import {
  // getWebLayoutStaticPaths,
  getWebLayoutStaticProps,
} from '@/layouts/web/webLayoutSSG';
// import useCustomer from '@/modules/core/data/hooks/useCustomer';
// import { Customer } from '@/modules/core/data/types/Customer';
import {createLogger} from '@/modules/core/logging/logger';
import {
  GetStaticPaths,
  GetStaticProps, GetStaticPropsResult,
  NextPage,
} from 'next';

import ReactDivWebAnnouncementTopBar from '@/modules/core/reactDivWeb/components/Announcements/TopBar/TopBar';

import {StaticPropsInput} from '@/app/types/StaticPropsInput';
import {getDashboardContentEditorLayoutStaticProps} from '@/layouts/dashboard/contentEditor/dashboardContentEditorLayoutSSG';
import {getReactDivApiConfig} from '@/modules/core/reactDivAPI/utils/getApiConfig';
import getSystemShellBySingularAPIID
  from '@/modules/core/reactDivAPI/utils/queries/system/getSystemShellBySingularAPIID';
import getShelledPageBySingularAPIID from '@/modules/core/reactDivAPI/utils/queries/web/getShelledPageBySingularAPIID';
import deepmerge from 'deepmerge';
import getClientProjectContentBySystemShellID
  from '@/modules/core/reactDivAPI/utils/queries/web/getClientProjectContentBySystemShellID';
import getSystemShelledFieldsBySystemShellID
  from '@/modules/core/reactDivAPI/utils/queries/system/getSystemShelledFieldsBySystemShellID';
import Annoucement from "@/components/centralbrisbanedental/Announcement";
import Topbar from "@/components/centralbrisbanedental/Topbar";
import NavBar from "@/components/centralbrisbanedental/NavBar/NavBar";
import Hero from "@/components/centralbrisbanedental/Hero/Hero";
import AppointmentRequestForm
  from "@/components/centralbrisbanedental/userActions/AppointmentRequestForm/AppointmentRequestForm";
import CTABannerStandard from "@/components/centralbrisbanedental/CTABannerStandard/CTABannerStandard";
import CTABannerImageDescriptive
  from "@/components/centralbrisbanedental/CTABannerImageDescriptive/CTABannerImageDescriptive";
import CTABannerSplitTiles from "@/components/centralbrisbanedental/CTABannerSplitTiles/CTABannerSplitTiles";
import TwoColumnContent from "@/components/centralbrisbanedental/TwoColumnContent/TwoColumnContent";
import ContentBackgroundImage from "@/components/centralbrisbanedental/ContentBackgroundImage/ContentBackgroundImage";
import Footer from "@/components/centralbrisbanedental/Footer/Footer";
import PageHeader from "@/components/centralbrisbanedental/page/Header/Header";
import FAQ from "@/components/centralbrisbanedental/FAQ/FAQ";
import TAB from "@/components/centralbrisbanedental/TAB/TAB";
import Callout from "@/components/centralbrisbanedental/Callout";
import Tabs from "@/components/centralbrisbanedental/Tabs/Tabs";

const fileLabel = 'pages/index';
const logger = createLogger({ // eslint-disable-line no-unused-vars,@typescript-eslint/no-unused-vars
  fileLabel,
});

/**
 * Only executed on the server side at build time.
 * Necessary when a page has dynamic routes and uses "getStaticProps".
 */
// export const getStaticPaths: GetStaticPaths<CommonServerSideParams> = getPublicLayoutStaticPaths({fallback:true});
// export const getStaticPaths: GetStaticPaths<CommonServerSideParams> = getPublicLayoutStaticPaths();

/**
 * Only executed on the server side at build time.
 *
 * @return Props (as "SSGPageProps") that will be passed to the Page component, as props.
 *
 * @see https://github.com/vercel/next.js/discussions/10949#discussioncomment-6884
 * @see https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 */
export const getStaticProps: GetStaticProps<SSGPageProps, CommonServerSideParams> = async (props: StaticPropsInput): Promise<GetStaticPropsResult<SSGPageProps>> => {
  const commonStaticProps: GetStaticPropsResult<SSGPageProps> = await getWebLayoutStaticProps()(props);
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('getStaticProps commonStaticProps', commonStaticProps); // eslint-disable-line no-console
  }
  if ('props' in commonStaticProps) {
    const config = getReactDivApiConfig();

    const [
      // Below is Web Module
      // currentShelledPage,
      // currentClientProjectSEOSettings,
      // currentShelledPageSeoSettings, // NOTE This is a dependency, should loop through these
      // currentClientProjectSEOSettings,
      // Above is Web Module
    ] = await Promise.all([
      // Below is Web Module
      // getShelledPageBySingularAPIID({config, slug: 'home'}),
      // getSystemShelledFieldsBySystemShellID({config, systemShellID: '630f756db23725aedbc16e7d'}),
      // getClientProjectContentBySystemShellID({
      //   config,
      //   clientID: commonStaticProps.props.reactDivClientID,
      //   projectID: commonStaticProps.props.reactDivClientProjectID,
      //   systemShellID: '630f756db23725aedbc16e7d',
      // }),
      // getBySingularAPIID({config, slug: "home"}),
      // Above is Web Module
    ]);

    return deepmerge(commonStaticProps, {
      props: {
        // Below is Web Module
        // currentShelledPage,
        // currentShelledPageSeoSettings,
        // currentClientProjectSEOSettings,
        // Above is Web Module
        builtAt: new Date().toISOString(),
      },
      // revalidate: regenerationDelay,
    });
    // return commonStaticProps;
  } else {
    return commonStaticProps;
  }
};

/**
 * SSG pages are first rendered by the server (during static bundling).
 * Then, they're rendered by the client, and gain additional props (defined in OnlyBrowserPageProps).
 * Because this last case is the most common (server bundle only happens during development stage), we consider it a default.
 * To represent this behaviour, we use the native Partial TS keyword to make all OnlyBrowserPageProps optional.
 *
 * Beware props in OnlyBrowserPageProps are not available on the server.
 */
type Props = {} & SSGPageProps<Partial<OnlyBrowserPageProps>>;

let alignerOrthodonticsContentA: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Everyone wants straight teeth but more and ' +
              'more patients are unwilling to wear conventional braces to achieve the result.  Having visible wires and brackets on the teeth has become unacceptable aesthetically which has led to the development of aligner orthodontics or “invisible braces”.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'It’s not just the look of metal braces that ' +
              'puts people off.  Metal braces have a reputation of being harder to maintain and clean.  Many people who have used metal braces have found them to be physically uncomfortable.  Aligner Orthodontics address these issues by providing a less intrusive, more comfortable and easier to manage process to straightening teeth.  In many cases, they work in the same amount of time and produce the same end result.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'relaxed dental patient receiving treatment',
              src: '/static/images/tiles/aligner-orthdontics-drill-sergeant-toothy.png.webp',
              height: 320,
              width: 463,
            },
            imageClasses: {
              textAlign: "center"
            }
          }
        ]
      },
    ]
  },
]
let alignerOrthodonticsContentB: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'With aligner orthodontics, the patient wears ' +
              'a series of clear, wafer-thin, removable aligners, which gently guide the teeth from their present position to the desired position.  Each aligner is worn 22 hours per day for 2 weeks to move the teeth a certain degree before the next aligner continues the straightening process.  The aligners are customised for each patient, giving predictable, effective results.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Due to their design, aligners have significant ' +
              'advantages over traditional braces with wires and brackets.  The aligners are clear so they appear nearly invisible to the eye.  They are wafer-thin so they are more comfortable to wear and cause less irritation and tissue trauma.  They are completely removable which makes it much easier to clean the teeth as well as eat and drink.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'heading',
            type: 'h3',
            value: 'What\'s The Best Way To Line Up?',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontWeight: "bold",
              fontSize: "text-2xl",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'When it comes to orthodontics and teeth ' +
              'straightening, most people prefer aligners over brackets and wires.  Here are some benefits of using aligners for teeth straightening:',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'richList',
            type: 'ul',
            value: [
              "No need for brackets and wires",
              "Virtually invisible when worn",
              "More socially acceptable",
              "Easier to maintain",
              "Can take out to clean the teeth and eat",
              "Less intrusive",
              "More comfortable",
              "Less trauma to soft tissues",
              "Just as effective as braces",
            ]
          }
        ]
      },
    ]
  },
]
let alignerOrthodonticsContentC: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'There are many brands of orthodontic ' +
              'aligners available such as Invisalign, ClearCorrect and ClearPath.  You may of heard more about some of these brands than others.  That is probably more to do with marketing then it is to do with results.  At Central Brisbane Dental, we choose to use ClearPath.  Why have we chosen to work with ClearPath?  Well for us the journey to the end result is just as important as the end result.  We are all about promoting short and long term dental health and aesthetics, and in our opinion ClearPath provides the best aligner to do this.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Unlike other brands, ClearPath’s patented ' +
              'technology allows each aligner to grip the teeth and move them precisely without the need for attachments on the teeth.  Attachments are usually shapes of plastic filling material bonded onto the teeth to help them move when wearing orthodontic aligners.  Although this filling material is removed after treatment is complete, they are disadvantageous during treatment.  Teeth with attachments are less aesthetically pleasing, are harder to clean and are not as smooth as teeth without attachments.  The filling material may also come off during eating and drinking, may be accidently swallowed and need to be replaced.',
            classes: {
              margin: "my-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'relaxed dental patient receiving treatment',
              src: '/static/images/tiles/aligner-orthodontics.png.webp',
              height: 320,
              width: 463,
            },
            imageClasses: {
              textAlign: "center"
            }
          }
        ]
      },
    ]
  },
]

/**
 * Example of a public page.
 */
const Index: NextPage<Props> = (props): JSX.Element => {
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('Index props', props); // eslint-disable-line no-console
  }
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
    };
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <>
      <div className="sticky top-0 z-10 shadow-md">
        <Annoucement
          mobilePrimaryTextValue="Extracted publication of ClearPath Orthocare case study by Dr Vincent Wan."
          desktopPrimaryTextValue="Extracted publication of ClearPath Orthocare case study by Dr Vincent Wan."
          tailwindWrapperClassNames={{
            tailwind: "bg-[#400068]"
          }}
          tailwindContainerClassNames={{
            tailwind: "mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8 flex flex-wrap items-center justify-between"
          }}
          destination="/static/pdf/case-study-dr-wan.pdf"
        />
        <Topbar
          scrollY={scrollY}
          style={{
            background: "bg-[#f3f3f3]"
          }}
        />
      </div>
      <NavBar/>
      <PageHeader
        title="Aligner Orthodontics"
        background="bg-[#400068]"
        backgroundImage="/static/images/headers/life-cycle-header-overlay.png"
      />
      <main>
        <TwoColumnContent
          title="Time For Your Teeth To Get In Line!"
          // heading="How to get to our dental clinic in Brisbane city & things to know before coming in."
          content={alignerOrthodonticsContentA}
        />
        <Callout
          mobilePrimaryTextValue="More information about aligner orthodontics"
          desktopPrimaryTextValue="More information about aligner orthodontics"
          iconColour={"#400068"}
          textClassNames={{
            colour: "text-black"
          }}
          tailwindWrapperClassNames={{
            tailwind: "bg-[#17AAAB]"
          }}
          tailwindContainerClassNames={{
            tailwind: "mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8 flex flex-wrap items-center justify-between"
          }}
          destination="/static/pdf/Central-Brisbane-Dental-Aligner-Orthodontics.pdf"
        />
        <Tabs
          wrapperClassNames={{
            background: "bg-[#400068]"
          }}
          containerClassNames={{
            spacing: "container mx-auto",
            padding: "py-8"
          }}
          heading="Aligner Orthodontics"
          headingClassNames={{
            fontSize: "text-2xl md:text-3xl",
            fontWeight: "font-bold",
            color: "text-white",
            padding: "py-4 px-4 md:px-0",
            alignment: "text-center md:text-left"
          }}
          headingEmphasis="Procedure and Cost"
          headingEmphasisClassNames={{
            color: "text-[#ff6600]"
          }}
          tabs={[
            {
              heading: "30 Minute Appointment – Free Cosmetic Consult",
              items: [
                {
                  heading: "Item 015 - Long Consultation",
                  content: [
                    `<strong>Description:</strong> Evaulation of teeth crowding and spacing, the bite and if
                    appropriate for clear aligner orthodontic treatment.`,
                    `<strong>Cost:</strong> Free, normally $66.`
                  ]
                },
                {
                  heading: "Additional Steps",
                  content: [
                    `Give referral form to X-ray Clinic to get OPG and Lat Ceph (full mouth and side profile 2D scans, bulk billed or subsidised by Medicare) - some practices charge $200 or more for these, we refer out as it is cheaper for the patient with Medicare coverage - Comprehensive evaluation of the teeth, jaw bone and side profile.`
                  ]
                }
              ]
            },
            {
              heading: "1 Hour Appointment – Record Taking to Produce Treatment Plan and Aligners",
              items: [
                {
                  heading: "Item 825 x2 - Clear Aligner Treatment Upper and Lower Teeth",
                  content: [
                    `<strong>Description:</strong> Includes record taking and analysis, treatment plan with before and
                      projected after images, all orthodontic review appointments, all aligners and a set of retainers.`,
                    `<strong>Cost:</strong> $2599 to $6000 depending on complexity of case and number of aligners needed.`
                  ]
                },
                {
                  heading: "Item 015 Long Consultation",
                  content: [
                    `<strong>Description:</strong> Orthodontic assessment and analysis of impressions and x-ray and
                    photographic records.`,
                    `<strong>Cost:</strong> no extra charge, normally $66.`
                  ]
                },
                {
                  heading: "Item 071 x2 Impressions of Upper and Lower Teeth",
                  content: [
                    `<strong>Description:</strong> Impressions of Upper and Lower Teeth.`,
                    `<strong>Cost:</strong> no extra charge, normally $180.`
                  ]
                },
                {
                  heading: "Item 072 Intraoral Photographic Records",
                  content: [
                    `<strong>Description:</strong> Intraoral Photographic Records.`,
                    `<strong>Cost:</strong> no extra charge, normally $90.`
                  ]
                },
                {
                  heading: "Item 073 Extraoral Photographic Records",
                  content: [
                    `<strong>Description:</strong> Extraoral Photographic Records.`,
                    `<strong>Cost:</strong> no extra charge, normally $90.`
                  ]
                }
              ]
            },
            {
              heading: "30 Minute Appointment - Discussion of Treatment Plan",
              items: [
                {
                  heading: "Appointment Process",
                  content: [
                    `<strong>Description:</strong> Discussion of Treatment Plan With Before and Projected After Images.`,
                    `<strong>Cost:</strong> no extra charge, normally $66.`
                  ]
                }
              ]
            },
            {
              heading: "30 Minute Appointment - Insertion of 1st Aligners",
              items: [
                {
                  heading: "Appointment Process",
                  content: [
                    `<strong>Description:</strong> Insertion of 1st Aligners and Discussion About Use.`,
                    `<strong>Cost:</strong> no extra charge, normally $66.`
                  ]
                }
              ]
            },
            {
              heading: "Regular 15 - 30 Minute Appointments",
              items: [
                {
                  heading: "Appointment Process",
                  content: [
                    `<strong>Description:</strong> Review of Aligner Progression, Adjustments as Needed.`,
                    `<strong>Cost:</strong> no extra charge, normally $66 per appointment.`
                  ]
                }
              ]
            },
            {
              heading: "Regular 15 Appointment - Insertion of Retainers",
              items: [
                {
                  heading: "Appointment Process",
                  content: [
                    `<strong>Description:</strong> Insertion of Retainers Once Aligner Treatment is Complete.`,
                    `<strong>Cost:</strong> no extra charge, normally $66 per appointment.`
                  ]
                }
              ]
            },
          ]}
        />
        <CTABannerImageDescriptive
          imageProperties={{
            layout: 'intrinsic',
            alt: 'happy toothy character',
            type: 'dimensions',
            src: '/static/images/tiles/sunbaking-toothy-teeth-whitening.png.webp',
            height: 285,
            width: 412.5,
          }}
          title="Philips Zoom"
          heading="Teeth Whitening for just $660!"
          description="Come in for a free consultation."
          buttonText="View terms and conditions"
          buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
          imageClasses={{
            textAlign: "center",
            padding: "p-5"
          }}
          titleClasses={{
            dynamicColour: '#ff6600',
            fontSize: 'text-base',
            fontWeight: 'semibold',
            letterSpacing: 'tracking-wider',
            uppercase: true,
          }}
          headingClasses={{
            margin: 'mt-2',
            fontSize: 'text-2xl sm:text-3xl',
            fontWeight: 'extrabold',
            letterSpacing: 'tracking-tight',
            colour: 'text-white',
          }}
          descriptionClasses={{
            margin: 'mt-3',
            fontSize: 'text-lg',
            colour: 'text-white'
          }}
          buttonClasses={{
            border: 'border border-transparent rounded-md',
            display: 'inline-flex',
            padding: 'px-5 py-3',
            dynamicBackground: '#17aaab',
            fontSize: 'text-base',
            fontWeight: 'medium',
            colour: 'text-black',
          }}
          classes={{
            position: 'relative',
            dynamicBackground: '#070707',
          }}
        />
        <FAQ
          enableHeading={true}
          faqs={[
            {
              question: "Can I Get Invisalign?",
              answer: "If you speak to a dentist about straightening your teeth and they recommend aligners, then you can get Invisalign. Invisalign is a well-known brand of clear aligners, but they are not the only brand. In Australia, people often think of all clear aligners as being Invisalign. There are many different brands of clear aligners. At Central Brisbane Dental we prefer to use ClearPath aligners. We believe ClearPath aligners are superior. In short, ClearPath use a patented micro crisscross pattern that allows the aligners to better grip your teeth. This avoids the need for the dentist to glue little bits of composite resin to the teeth that is commonly used with other clear aligner brands. These bits of composite resin are disliked for being visually noticeable and hard to clean, and often need to be replaced as they come away. Cost is also a factor, Invisalign is the established brand in Australia and costs to our patients are in most cases lower when using ClearPath."
            },
            {
              question: "Do Aligners Work?",
              answer: "In most straight forward cases, clear aligners work as well or better than traditional metal and wire braces. From a patient perspective, clear aligners are advantageous as they are easier than braces to get used to, and more socially acceptable as they are virtually invisible. Aligners can also be taken out to eat and clean the teeth while braces cannot. In complex cases, braces are still needed to move the teeth. You can book a free cosmetic consultation with one of our dentists to evaluate your ability to straighten your teeth with aligner orthodontics."
            },
            {
              question: "Are Aligners Bad For Your Teeth?",
              answer: "A patient who is straightening their teeth with aligner orthodontics is better able to practice good dental hygiene compared to someone who is receiving treatment with braces. Aligners can and should be removed during eating and drinking, and are kept clean separately from the teeth. Patients are able to brush and floss as normal by removing the aligners. If food remains are caught in braces, it can be difficult for the patient to clean these areas. As with all dental treatment, it is important that the patient practices good dental hygiene during treatment and follows the directions provided by their dentist with their use of clear aligners. Failure to keep aligners in at most times and not having regular checkups can lead to complications, most of which are not serious but could have been avoided."
            },
            {
              question: "How Long Do I Need To Wear Aligners?",
              answer: "The length of time you need to wear aligners varies from case to case. In some instances you may only need minor alignment and a 12 to 24 week course might be suitable for you. In the most complex cases, your course could be as long as 18 months. Most cases take approximately 12 months. If you do not use your aligners are recommended, your treatment time may increase."
            },
            {
              question: "Are Aligners Better Than Braces?",
              answer: "From a teeth straightening point of view, aligners and braces both provide the same desired straightening result. They differ on how the result is achieved. From a purely aesthetic point of view, aligners are better than braces due to them being virtually invisible. From a dental hygiene perspective, aligners are better than braces as they can be removed for eating and cleaning of the teeth."
            },
            {
              question: "How Much Do Aligners Cost?",
              answer: "Costs of aligner treatment are directly related to the complexity of the teeth straightening you require and the number of aligners needed to treat the case. If you have fairly minor teeth crowding or spacing, you may only require a few aligners to correct this, and the cost starts at $2599. If you have severe teeth crowding or spacing, you will need many aligners to correct this, and the cost may be up to $6000. We allow patients to pay 50% upfront and pay off the remaining balance over the course of their treatment."
            },
            {
              question: "Do Clear Aligners Hurt?",
              answer: "As with any dental treatment, there can be some pain associated with clear aligners. Some discomfort can happen when you start using aligners for the first time or switch to a new aligner. This discomfort is typically minor and passes within a few days. If pain persists you can reach out to your dentist who can check and make sure the aligners are working as intended. Clear aligners are straightening your teeth through a gradual process of movement and some minor discomfort should be expected. Major pain levels may be a symptom of an underlying dental issue that may require specific treatment and you should always consult your dentist for a dental emergency of this nature."
            }
          ]}
        />

        <TwoColumnContent
          title="It's Our Little Secret"
          // heading="How to get to our dental clinic in Brisbane city & things to know before coming in."
          content={alignerOrthodonticsContentB}
        />
        <CTABannerSplitTiles
          dentist="vincent"
          heading="Did you know?"
          value="Did you know we are preferred providers for CBHS, HCF, nib, Australian Unity, Defence Health and Peoplecare and give you the best rate?"
          buttonText="View terms and conditions"
          buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
          hasInset={true}
          insetClasses={{
            display: 'hidden lg:block',
            position: 'absolute top-0 inset-x-0',
            height: 'h-1/2',
            dynamicBackground: '#400068'
          }}
          buttonClasses={{
            border: 'border border-transparent rounded-md',
            display: 'inline-flex',
            padding: 'px-5 py-3',
            dynamicBackground: '#17aaab',
            fontSize: 'text-base',
            fontWeight: 'medium',
            colour: 'text-black',
          }}
          classes={{
            position: 'relative',
            dynamicBackground: '#fff',
            padding: 'py-16'
          }}
        />
        <TwoColumnContent
          title="Lots Of Ways To Straighten Things Out!"
          // heading="How to get to our dental clinic in Brisbane city & things to know before coming in."
          content={alignerOrthodonticsContentC}
        />
        {/* Content Layout Two - Repeated */}
        <section
          data-component-type="content-only"
        >

          <div
            className="container mx-auto flex"
          >

            <div className="w-full flex justify-end py-8">

              <div className="flex flex-col justify-center px-2">

                <h2 className="mt-2 text-black text-3xl font-extrabold tracking-tight sm:text-4xl text-center">
                  Why ClearPath Clear Aligners vs Invisalign When It Comes To Aligner Orthodontics?
                </h2>

                <p className="mt-5 text-lg text-gray-900 mr-8">
                  Aligner orthodontics or aligner orthodontic treatment simply means using clear aligners to straighten
                  teeth. Clear aligners are basically thin, see-through, layers of special plastic material that are
                  moulded to precisely fit your teeth. They grip your teeth and move them by making your teeth follow
                  the same shape as the moulded material. By wearing a series of clear aligners, teeth will move little
                  by little over time, giving straight teeth after all sets are completed. Invisalign is one brand of
                  clear aligners. It is well known as it was the first brand to provide aligner orthodontics in Brisbane
                  and around the world. There are now many brands of clear aligners. So what’s the difference between
                  other brands of clear aligners vs Invisalign? Basically all brands of clear aligners are very similar
                  and all effective. At our Brisbane CBD dental clinic, we use ClearPath clear aligners over Invisalign
                  or other brands. This is because Invisalign and other brands of clear aligners often require the
                  dentist to glue little shapes for filling material onto the teeth, called attachments, to help their
                  clear aligners grip and move the teeth. Patients and dentists alike hate these attachments as they are
                  more visible, don’t feel nice to the tongue, are harder to clean, and can come away and need
                  replacing. ClearPath clear aligners have a special patented surface that grips and moves the teeth
                  without the need for these attachments. When you come see us at our Brisbane CBD dental clinic for
                  ClearPath aligner orthodontics, our dentists will take photos of your teeth and smile, moulds of your
                  teeth and gums, and give you a referral form to get special x-rays done that are bulk billed by
                  Medicare if you have a Medicare card. These are sent to ClearPath and are analysed by their team of
                  specialist orthodontists who provide us with an aligner orthodontics treatment plan for your case
                  which includes before and after images. The clear aligners are made once you and your dentist are
                  happy to proceed with the treatment plan or the treatment plan can be modified. The treatment is then
                  carried out by your dentist so the aligner orthodontics cost to you is much reduced. Patients still
                  receive input from a team of orthodontic specialists and the prices for clear aligners are much more
                  affordable to patients in this way compared to going to a specialist orthodontist.
                </p>

              </div>

            </div>

          </div>

        </section>
      </main>
      <Footer/>
    </>
  );
};

export default Index;
